export default{

    scrollToTop(){
        let scrollStep = -window.scrollY / (100 / 10)
        let scrollInterval = setInterval(function () {
            if (window.scrollY != 0) {
                window.scrollBy(0, scrollStep);
            }
            else clearInterval(scrollInterval);
        }, 10);
    }

}


// WEBPACK FOOTER //
// ./src/utilities/ScrollUtilities.js